export default __webpack_public_path__ + "static/1267-4d40da6b5fb5f5d8e17cad90ba172c07.png";